import useGetApi from 'src/api/useGetApi';
import { CustomerProductDTO } from 'src/types/application/inventory-management/CustomerProductDTO';

interface GetCustomerProductResponse {
  customerProduct: CustomerProductDTO;
}

const useCustomerProduct = (customerProductId?: string, enabled?: boolean) => {
  return useGetApi<GetCustomerProductResponse>({
    endpoint: `inventory-management/products-v2/customer-products/${customerProductId}`,
    options: {
      enabled: !!customerProductId && !!enabled,
    },
  });
};

export default useCustomerProduct;
